export default "__VITE_ASSET__pk6$1dCe__"